import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import "bootstrap/dist/css/bootstrap.min.css"
import 'bootstrap'
import VueGoodTablePlugin from 'vue-good-table-next';
import 'vue-good-table-next/dist/vue-good-table-next.css'
import { plugin, defaultConfig } from '@formkit/vue'
import '@formkit/themes/genesis'
import mitt from 'mitt';  
                
const emitter = mitt();  

const app = createApp(App)
app.provide('emitter', emitter); 
app.use(store)
    .use(VueGoodTablePlugin)
    .use(router)
    .use(plugin, defaultConfig)
    .mount('#app')